// extracted by mini-css-extract-plugin
export default {"shine":"stats_shine__tEl4o"};